import { Tag, TagLabel } from "~/react/ui/tag"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { format } from "date-fns"

const sourceClasses = cva("ds-sources-list__item", {
  variants: {
    outdated: {
      true: "ds-sources-list__item--outdated",
    },
  },
})

export interface SourceType {
  domain: string
  link: string
  extracted_on: Date
  last_seen_on: Date
  still_on_page: boolean
}

export const Source = ({ source }: { source: SourceType }) => {
  const { link, last_seen_on, still_on_page } = source

  return (
    <li className={cn(sourceClasses({ outdated: !still_on_page }))}>
      {still_on_page ? null : (
        <Tag size="sm">
          <TagLabel>Removed</TagLabel>
        </Tag>
      )}

      <a className="ds-sources-list__link" href={link} rel="noopener noreferrer nofollow" target="_blank">
        {link}
      </a>
      <time className="ds-sources-list__date">{format(last_seen_on, "MMM d, yyyy")}</time>
    </li>
  )
}
